import { makeDeleteRequest } from 'owa-ows-gateway';

export async function removeCalendarProviderAccount(
    calendarProviderAccountId: string
): Promise<void> {
    await makeDeleteRequest(
        `ows/api/beta/calendarProviderAccounts/${calendarProviderAccountId}`,
        undefined /* requestObject */,
        undefined /*correlationId*/,
        undefined /*returnFullResponse*/,
        undefined /*customHeaders*/,
        true /*throwServiceError*/
    );
}
